<template>
	<div class="">
		<div class="flex" style="margin-top: 10px;">
			<el-dropdown @command="commandDrop">
				<div class="drop-style">
					{{dropInfo ? dropInfo :'区县'}}<i class="el-icon-arrow-down el-icon--right"></i>
				</div>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item v-for="item in cityList" :command="item">{{item}}</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<!-- 	<el-dropdown style="margin-left: 15px;">
				<div class="drop-style">
					行业<i class="el-icon-arrow-down el-icon--right"></i>
				</div>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item>黄金糕</el-dropdown-item>
					<el-dropdown-item>狮子头</el-dropdown-item>
					<el-dropdown-item>螺蛳粉</el-dropdown-item>
					<el-dropdown-item>双皮奶</el-dropdown-item>
					<el-dropdown-item>蚵仔煎</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown> -->
		</div>
		<div class="flex alit" style="margin:10px 0 0px 0">
			<div class="flexCol alit">

				<xyEchartsVue class="xy"></xyEchartsVue>
				<div class="jr">进入</div>
			</div>
			<div class="">
				<div class="" v-if="dropInfo">
					<div class="xy-list flex justb" v-for="item in list[dropInfo].slice(0,7)">
						<div class="comname">{{item}}</div>
						<!-- <div class="comlevel">A+</div> -->
					</div>
				</div>
				<div class="" v-else>
					<div class="xy-list flex justb" v-for="item in allList">
						<div class="comname">{{item}}</div>
						<div class="comlevel">A+</div>
					</div>
				</div>
				<div class="" v-if="dropInfo && list[dropInfo].length < 7">
					<div class="xy-list2 flex justb" v-for="item in  7 - list[dropInfo].length">
					</div>
				</div>

				<!-- 	<div class="xy-list flex justb">
					<div class="comname">企业名称</div>
					<div class="comlevel">A+</div>
				</div>
				<div class="xy-list flex justb">
					<div class="comname">企业名称</div>
					<div class="comlevel">A+</div>
				</div>
				<div class="xy-list flex justb">
					<div class="comname">企业名称</div>
					<div class="comlevel">A+</div>
				</div>
				<div class="xy-list flex justb">
					<div class="comname">企业名称</div>
					<div class="comlevel">A+</div>
				</div>
				<div class="xy-list flex justb">
					<div class="comname">企业名称</div>
					<div class="comlevel">A+</div>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	import xyEchartsVue from './xyEcharts.vue';
	export default {
		components: {
			xyEchartsVue
		},
		data() {
			return {
				dropInfo: '',
				list: {
					'渝中区': ['珮姐老火锅', '奇火锅', '鲁西肥牛', '记忆叁城火锅', '德庄时代天街店', '德庄溯源店', '小天鹅洪鼎食府', '小天鹅佳洪崖洞店', '刘一手东水门店',
						'周师兄腰片老火锅', '渝大狮毛肚老火锅', '洞亭火锅'
					],
					'江北区': ['德庄火锅', '二筒老火锅', '观音桥后火锅', '红房子火锅', '李常在观音桥店', '大刀张鲜毛肚火锅', '秦妈火锅', '珮姐老火锅', '亖井火锅', '洋河村火锅',
						'渝味晓宇火锅'
					],
					'沙坪坝区': ['秦妈火锅', '刘一手磁器口店', '渝酷辣火锅串串', '莺花渡火锅', '德庄火锅', '归井老火锅', '田庄老火锅', '矿火锅', '大龙火锅', '王少龙火锅',
						'镇三关火锅'
					],
					'九龙坡区': ['周师兄火锅', '渝厨生态火锅', '刘一手火锅', '杨光会鲜货火锅', '卤校长老火锅', '二郎老火锅', '珮姐老火锅', '渝宗老灶火锅'],
					'南岸区': ['巴倒烫火锅', '后火锅总店', '秦妈火锅', '德庄火锅1891店', '龙门九号火锅', '巴倒烫重庆陆派火锅', '大刀张鲜毛肚火锅', '鲜龙井火锅公园', '枇杷园火锅',
						'楠火锅', '受气牛肉'
					],
					'高新区': ['刘一手火锅', '天赐生态火锅', '周师兄火锅', '矿火锅', '大龙火锅', '渝味响火锅'],
					'北碚区': ['家福火锅', '刘一手火锅', '德庄火锅', '秦妈火锅', '盬子鸡火锅', '巴将军原味火锅'],
					'渝北区': ['谭英雄火锅', '秦妈火锅', '德庄龙头寺店', '垦火锅', '周师兄腰片老火锅', '渝宗老灶火锅', '亖井火锅', '卤校长老火锅', '大龙火锅'],
					'万州区': ['渝德餐饮公司', '刘一手火锅', '秦妈火锅', '德庄火锅', '老盐坊棚棚火锅', '五桥老火锅', '江边城外火锅'],
					'合川区': ['赖记火锅', '牧哥火锅', '刘一手火锅', '秦妈火锅', '德庄火锅', '少水粉火锅', '滨江路老火锅'],
					'綦江区': ['高老九火锅', '刘一手火锅', '秦妈火锅', '德庄火锅', '古剑山老火锅', '北渡鱼火锅']

				},
				cityList: ['渝中区', '江北区', '沙坪坝区', '九龙坡区', '南岸区', '高新区', '北碚区', '渝北区', '万州区', '合川区', '綦江区'],
				allList: ['珮姐老火锅', '奇火锅', '鲁西肥牛', '记忆叁城火锅', '德庄时代天街店', '德庄溯源店', '小天鹅洪鼎食府']
			}
		},
		created() {

		},
		methods: {
			commandDrop(e) {
				this.dropInfo = e
			}
		}
	}
</script>

<style scoped lang="scss">
	.drop-style {
		width: 80px;
		height: 30px;
		background: rgba(115, 141, 236, 0.6);
		border-radius: 5px 5px 5px 5px;
		cursor: pointer;
		font-family: PingFang SC, PingFang SC;
		font-weight: 500;
		font-size: 11px;
		color: #FFFFFF;
		text-align: center;
		line-height: 30px;
	}

	.jr {
		width: 110px;
		height: 28px;
		background-image: url('https://qgst.obs.cn-southwest-2.myhuaweicloud.com/rabbit/%E8%BF%9B%E5%85%A5%E8%83%8C%E6%99%AF%402x.png');
		background-size: 100% 100%;
		text-align: center;
		line-height: 28px;

		font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
		font-weight: 900;
		font-size: 16px;
		color: #FFFFFF;
		text-shadow: 0px 3px 7px rgba(53, 44, 0, 0.5);
		margin-top: -20px;
	}

	.comlevel {
		font-family: DIN-BoldItalic, DIN-BoldItalic;
		font-weight: 900;
		font-size: 16px;
		color: #EDFBFF;
		background: linear-gradient(90deg, #FFF600 21%, #FFFCA2 83%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		font-style: italic;
		line-height: 30px;
	}

	.comname {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
		line-height: 30px;
	}

	.xy-list {
		width: 140px;
		height: 30px;
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E4%BF%A1%E7%94%A8%E5%88%97%E8%A1%A8%402x.png');
		background-size: 100% 100%;
		padding: 0 20px;
		margin-bottom: 5px;
	}
	
	.xy-list2{
		width: 140px;
		height: 30px;
		padding: 0 20px;
		margin-bottom: 5px;
	}

	.xy {
		width: 200px;
		height: 200px;
	}
</style>